import { WorkflowLogEntry, WorkflowStatus } from '../../ports/WorkflowService';

export const colors: Record<WorkflowStatus | WorkflowLogEntry['level'], string> = {
  [WorkflowStatus.COMPLETED]: 'success',
  [WorkflowStatus.FAILED]: 'danger',
  [WorkflowStatus.RUNNING]: 'primary',
  [WorkflowStatus.CREATED]: 'primary',
  info: 'primary',
  warn: 'warning',
  error: 'danger',
};
